import Col from 'components/ui-elements/Col'
import Row from 'components/ui-elements/Row'
import { MyConst } from 'data/MyConst'
import useAxiosFunction from 'hooks/useAxiosFunction'
import useMsgBox from 'hooks/useMsgBox'
import React, { useEffect, useState } from 'react'
import { StyledDropZone } from 'react-drop-zone'
import 'react-drop-zone/dist/styles.css'
import { useDispatch } from 'react-redux'
import { utilityAction } from 'reduxStore'

const DropUpload = (props) => {
    const dispatch = useDispatch()

    let { label = "Upload/Drop File di Sini",
        allowedExtentions = ["jpg", "jpeg", "png", "pdf", "docx", "doc", "zip", "rar"],
        data = {},
        name = "dokumen",
        dropname = "file",
        url = "",
        onError = () => { },
        onSuccess = () => { },
        fontSize = "15px",
        padding = "1em",
        setValue = () => { },
        validation,
        value = "",
        auth = true,
        register, handleSubmit, watch, control,
        renderFunc,
        error,
        ...rest } = props

    //jika tak ada dropname, samakan dengan name
    dropname = dropname ? dropname : name
    //jika tak ada informasi data.name, isi dengan dropname
    //data.name ini field file untuk diproses di server
    if (!data?.name) {
        data["name"] = dropname
    }
    const [resp, errorf, loading, axiosFetch] = useAxiosFunction();
    const [showMsg] = useMsgBox();
    const [myfname, setMyfname] = useState(value)
    const [mylabel, setMylabel] = useState(label)

    const doUpload = async (file) => {
        dispatch(utilityAction.setLoading(true))
        const filename = file?.name
        const ext = filename.split(".").pop().toLowerCase()
        let allowed = false
        allowedExtentions.forEach(element => {
            allowed = allowed || element.toLowerCase() === ext
        });

        if (!allowed) {
            await showMsg("Informasi", "Anda hanya diperkenan mengupload file bertipe: " + allowedExtentions.join(", "))
            dispatch(utilityAction.setLoading(false))
            return
        }
        const formData = new FormData();
        formData.append(dropname, file)

        const keys = Object.keys(data);
        keys.forEach((key, idx) => {
            formData.append(key, data[key])
        });

        const hasil = await axiosFetch({
            method: 'POST',
            url: url,
            data: formData,
            auth,
            multipart: true
        })

        dispatch(utilityAction.setLoading(false))
        if (hasil?.data?.success === true) {
            setValue(name, hasil?.data?.filename)
            setMyfname(hasil?.data?.filename)
            setMylabel(filename)
            await showMsg("Informasi", "Data berhasil diupload.")
            onSuccess()
        } else if (hasil?.data?.success === false) {
            await showMsg("Error", hasil?.message)
            onError(hasil?.message)
        } else {
            await showMsg("Error", "Tidak terhubung ke server!")
            onError("Tidak terhubung ke server!")
        }
    }

    useEffect(() => {
        if (value) {
            setMyfname(value)
            setMylabel(value)
        } else {
            setMyfname("")
            setMylabel(label)
        }
    }, [label, value])

    const sz = myfname ? 2 : 0
    return (
        mylabel && <div>
            <Row>
                <Col size={12 - sz}>
                    <input type={"hidden"} {...rest} {...register(name, validation)} />
                    <StyledDropZone style={{ fontSize: fontSize, padding: padding }} onDrop={(file, text) => doUpload(file)}>{mylabel}</StyledDropZone>

                    <center>{error && <span className="text-danger">{error}</span>}</center>
                </Col>
                {myfname && <Col size={sz}>
                    <a target="_blank" className={"btn  btn-primary btn-block "} href={MyConst.URLASET + "/" + data?.location + "/" + myfname}>
                        <i className={"fa fa-download"} />
                    </a>
                </Col>}
            </Row>
        </div>
    )
}

export default DropUpload
